import React, { Component } from "react";
import { connect } from "react-redux";
import { AlphaPicker, SketchPicker } from "react-color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Button } from "@revvsales/components";

import ImageChangePopup from "../../../commonComponents/DropzoneFiles/ImageChangePopup";
import NO_BACKGROUND_IMAGE from "../../../assets/No-bg-image.png";
import { ASSET } from "../../../constants";
import { ConfirmationBox } from "../../../commonComponents";

const { COLORS, IMAGE_POSITION_OPTIONS } = ASSET;

class CutomizeCoverpagePane extends Component {
  state = {
    imageTransparencyValue: { r: 24, g: 32, b: 69, a: 1.0 },
    colorTransparencyValue: { r: 24, g: 32, b: 69, a: 0 },
    backgroundColorValue: { r: 24, g: 32, b: 69, a: 0.6 },
    image: "",
    showImageOptions: false,
    currentImagePosition: "Center Right",
    showImagePositionDropdown: false,
    showColorOptions: false,
    showChangeImagePopup: false,
    showConfirmationPopup: false,
    errMsg: "",
    // AltTextValue: "",
    // addedAltTextBool: false,
  };

  componentDidMount = () => {
    const {
      backgroundImage,
      imageTransparency,
      colorTransparency,
      background,
      altText,
    } = this.props.sectionData;

    let backgroundURL = "";
    if (
      backgroundImage &&
      typeof backgroundImage === "string" &&
      (backgroundImage.startsWith("https") ||
        backgroundImage.startsWith("/static") ||
        backgroundImage.startsWith("data"))
    ) {
      backgroundURL = backgroundImage;
    } else if (backgroundImage) {
      backgroundURL = this.props.imageBaseUrl + backgroundImage;
    }

    this.setState(prevState => ({
      image: backgroundURL || "",
      imageTransparencyValue: {
        ...prevState.imageTransparencyValue,
        a: imageTransparency || 1.0,
      },
      AltTextValue: altText || "",
      colorTransparencyValue: {
        ...prevState.colorTransparencyValue,
        a: colorTransparency || 0,
      },
      backgroundColorValue: background,
    }));
  };

  componentWillReceiveProps(nextProps) {
    const {
      background,
      backgroundImage,
      colorTransparency,
      imagePosition,
      imageTransparency,
    } = nextProps.sectionData;
    let backgroundURL = "";
    if (
      backgroundImage &&
      typeof backgroundImage === "string" &&
      (backgroundImage.startsWith("https") ||
        backgroundImage.startsWith("/static") ||
        backgroundImage.startsWith("data"))
    ) {
      backgroundURL = backgroundImage;
    } else if (backgroundImage) {
      backgroundURL = this.props.imageBaseUrl + backgroundImage;
    }
    this.setState(prevState => ({
      image: backgroundURL || "",
      imageTransparencyValue: {
        ...prevState.imageTransparencyValue,
        a: imageTransparency || 1.0,
      },
      colorTransparencyValue: {
        ...prevState.colorTransparencyValue,
        a: colorTransparency || 0,
      },
      backgroundColorValue: background,
      currentImagePosition: imagePosition,
    }));
  }

  _changePosition = e => {
    e.preventDefault();
    this.setState({
      currentImagePosition: e.target.textContent,
    });
    this.props.changeBackgroundImagePosition(e.target.textContent);
  };

  _changeImageTransparencyValue = e => {
    this.setState({
      imageTransparencyValue: e.rgb,
    });
    this.props.changeCoverpageImageOpacity(e.rgb.a);
  };

  _changeColorTransparencyValue = e => {
    this.setState({
      colorTransparencyValue: e.rgb,
    });
    this.props.changeCoverpageColorOpacity(e.rgb.a);
  };

  _colorChange = e => {
    this.setState({
      backgroundColorValue: e.hex,
    });
    this.props.changeBackgroundColor(e.hex);
  };

  _onImageChange = event => {
    this.props.changeCoverpageColorOpacity(this.state.colorTransparencyValue.a);
    this.props.changeCoverpageImageOpacity(this.state.imageTransparencyValue.a);
    if (event[0] && event[0].file) {
      if (!event[0].fileType.includes("image")) {
        this.setState({
          errMsg: "Only .jpeg, .jpg and .png files are supported",
        });
        return;
      }
      this.props
        .uploadImageService(event[0].file)
        .then(res => {
          this.setState({
            image: this.props.imageBaseUrl + res.Image.Path,
            showImageOptions: false,
            showChangeImagePopup: false,
            errMsg: "",
            AltTextValue: "",
          });
          this.props.changeBackgroundImage(
            res.Image.Path,
            this.state.AltTextValue,
          );
        })
        .catch(err => console.debug(err));
    } else {
      const img = event.regular;
      this.setState({
        image: img,
        showImageOptions: false,
        showChangeImagePopup: false,
        errMsg: "",
      });
      this.props.changeBackgroundImage(img, this.state.AltTextValue);
    }
  };

  _onCloseImagePopup = () => {
    this.setState({
      showChangeImagePopup: false,
    });
  };

  _togglePopUp = (type, flag) => {
    this.setState({ [type]: flag });
  };

  // _onChange = e => {
  //   this.setState({ AltTextValue: e.target.value });
  // };

  // _handleKeyDown = e => {
  //   const { AltTextValue } = this.state;
  //   let { addedAltTextBool } = this.state;
  //   if (e.key === "Enter" && AltTextValue) {
  //     addedAltTextBool = true;
  //     Toastr.showToastr({
  //       className: "is-success",
  //       message: addedAltTextBool ? "Alt-text has been added successfully" : "",
  //       timeout: 2000,
  //     });
  //     this.props.changeBackgroundImage(this.state.image, AltTextValue);
  //   }
  // };

  render() {
    const currentBgColor = {
      background: this.state.backgroundColorValue,
    };

    if (this.state.showChangeImagePopup) {
      return (
        <ImageChangePopup
          show={this.state.showChangeImagePopup}
          onCloseImagePopup={this._onCloseImagePopup}
          uploadDocument={this._onImageChange}
          type="coverPage"
          errMsg={this.state.errMsg}
        />
      );
    }

    if (this.state.showConfirmationPopup) {
      return (
        <ConfirmationBox
          show={this.state.showConfirmationPopup}
          closePopup={() => this._togglePopUp("showConfirmationPopup", false)}
          header="Are you sure you want to restore theme to default ?"
          subHeader="Once modified, applied theme data will be lost"
          checkboxLabel="Yes, I want to restore"
          confirmAction={this.props.resetTheme}
          okBtnText="Restore default"
        />
      );
    }

    return (
      <div
        className="coverpage-theme-conatiner  animated fadeinright"
        onBlur={() => {
          this.setState({
            showImagePositionDropdown: false,
            showImageOptions: false,
          });
        }}>
        <div className="notes-header">
          <div
            className="right-pane-title back"
            role="button"
            tabIndex={0}
            onClick={this.props.closeCoverpageThemePane}
            onKeyPress={() => {}}>
            <div>Cover themes - {this.props.sectionData.appliedTheme}</div>
            <div>
              <i>
                <FontAwesomeIcon icon={["far", "times-circle"]} />
              </i>
            </div>
          </div>
        </div>
        <div className="notes-container">
          <div className="content-scroll">
            <span className="addproduct-info margin-bottom">
              Change the cover page elements such as image, background and
              transparency
            </span>
            <span className="collab-section-subtitle">Image options</span>
            <div className="coverpage-customize-options">
              <div className="cover-page-bg">
                <span className="cover-page-titlewrapper">
                  <span className="cover-page-bgtitle">Background image</span>
                  <span className="cover-page-subtitle">
                    Click on the image to replace it
                  </span>
                </span>
                <div className="cover-page-bgchange">
                  <div
                    className="image-wrapper"
                    data-test="cutomize-coverpage-pane-bg-image-btn"
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      this.setState(prevState => ({
                        showImageOptions: !prevState.showImageOptions,
                        showColorOptions: false,
                      }));
                    }}
                    onKeyPress={() => {}}>
                    <span
                      className={`selected-image ${
                        this.state.showImageOptions ? "open" : ""
                      }`}>
                      <FontAwesomeIcon icon={["far", "edit"]} />
                    </span>
                    <img
                      src={
                        this.state.image === ""
                          ? NO_BACKGROUND_IMAGE
                          : this.state.image
                      }
                      alt={
                        this.state.AltTextValue === ""
                          ? ""
                          : this.state.AltTextValue
                      }
                    />
                  </div>
                  {this.state.showImageOptions ? (
                    <ul className="image-option-btns-wrapper">
                      <li
                        className="image-option-btn upload-image-btn"
                        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                        role="button"
                        tabIndex={0}
                        onMouseDown={() => {
                          this.setState({
                            showChangeImagePopup: true,
                            showImageOptions: false,
                            showColorOptions: false,
                          });
                        }}
                        onKeyPress={() => {}}>
                        Change Image
                      </li>
                      <li
                        className="image-option-btn remove-image-btn"
                        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                        role="button"
                        tabIndex={0}
                        onMouseDown={() => {
                          this.props.removeBackgroundImage();
                          this.setState({
                            image: "",
                          });
                        }}
                        onKeyPress={() => {}}>
                        Remove Image
                      </li>
                    </ul>
                  ) : null}
                </div>
              </div>

              <div className="cover-page-bg">
                <span className="cover-page-bgtitle">Image position</span>
                <div className="cover-page-bgchange">
                  <div
                    className={`image-positioning-dropdown ${
                      this.state.showImagePositionDropdown ? "open" : ""
                    }`}
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                    role="button"
                    tabIndex={0}
                    data-test="cutomize-coverpage-pane-image-position-dropdown-btn"
                    onMouseDown={() => {
                      this.setState(prevState => ({
                        showImagePositionDropdown: !prevState.showImagePositionDropdown,
                        showColorOptions: false,
                      }));
                    }}>
                    {this.state.currentImagePosition}
                    <i>
                      <FontAwesomeIcon icon={["far", "angle-down"]} />
                    </i>
                  </div>
                  {this.state.showImagePositionDropdown ? (
                    <div className="custom-style-wrapper">
                      <ul className="custom-style-options">
                        {IMAGE_POSITION_OPTIONS.map(value => (
                          <li // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                            role="button"
                            tabIndex={0}
                            onMouseDown={this._changePosition}>
                            {value}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="cover-page-image">
                <span className="cover-page-imagetitle">
                  Image transparency
                </span>
                <Tooltip
                  placement="top"
                  overlay={`${Math.floor(
                    this.state.imageTransparencyValue.a * 100,
                  )}%`}
                  align={{ offset: [0, 3] }}>
                  <span className="cover-page-slider">
                    {" "}
                    <AlphaPicker
                      width="245px"
                      height="16px"
                      color={this.state.imageTransparencyValue}
                      onChange={e => this._changeImageTransparencyValue(e)}
                      data-test="cover-page-image-slider"
                    />
                  </span>
                </Tooltip>
              </div>
              {/* <Label htmlFor="userEmail">Add alt-text to the image</Label>
              <div className="inviteteammatespopup-copyblock">
                <Input
                  onChange={this._onChange}
                  onKeyDown={this._handleKeyDown}
                  className="alt-text-input"
                  type="text"
                  placeholder="Enter description"
                  value={this.state.AltTextValue}
                />
              </div> */}
            </div>
            <span className="collab-section-subtitle">Color options</span>
            <div className="coverpage-customize-options">
              <div className="cover-page-bg">
                <span className="cover-page-titlewrapper">
                  <span className="cover-page-bgtitle">Background color</span>
                  <span className="cover-page-subtitle">
                    Click on the color to change it
                  </span>
                </span>
                <div className="cover-page-bgchange">
                  <span
                    className={`selected-image ${
                      this.state.showColorOptions ? "open" : ""
                    }`}>
                    <FontAwesomeIcon icon={["far", "edit"]} />
                  </span>
                  <div
                    className="bgcolor-wrapper"
                    role="button"
                    data-test="cutomize-coverpage-pane-bgcolor-change-btn"
                    tabIndex={0}
                    style={currentBgColor}
                    onClick={() => {
                      this.setState(prevState => ({
                        showColorOptions: !prevState.showColorOptions,
                        showImageOptions: false,
                        showImagePositionDropdown: false,
                      }));
                    }}
                    onKeyPress={() => {}}
                  />
                  {this.state.showColorOptions ? (
                    <div className="color-option-picker">
                      <SketchPicker
                        color={this.state.backgroundColorValue}
                        onChange={e => this._colorChange(e)}
                        presetColors={COLORS}
                        width={225}
                        disableAlpha
                        data-test="color-option-picker"
                      />
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="cover-page-image">
                <span className="cover-page-imagetitle">
                  Color transparency
                </span>
                <Tooltip
                  placement="top"
                  overlay={`${Math.floor(
                    this.state.colorTransparencyValue.a * 100,
                  )}%`}
                  align={{ offset: [0, 3] }}>
                  <span className="cover-page-slider">
                    {" "}
                    <AlphaPicker
                      width="245px"
                      height="16px"
                      color={this.state.colorTransparencyValue}
                      onChange={e => this._changeColorTransparencyValue(e)}
                      data-test="cover-page-color-slider"
                    />
                  </span>
                </Tooltip>
              </div>
            </div>
            <div className="coverpage-customize-options">
              <Button
                className="revv-btn-secondary"
                data-test="cutomize-coverpage-pane-reset-btn"
                onClick={() =>
                  this._togglePopUp("showConfirmationPopup", true)
                }>
                Reset to default
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { image_base_url: imageBaseUrl } = state.DocumentStore.document;

  return {
    imageBaseUrl,
  };
};

export default connect(
  mapStateToProps,
  null,
)(CutomizeCoverpagePane);



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/CutomizeCoverpagePane/index.js